import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

interface InputBoxPhoneProps {
  label: string;
  name: string;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  onBlur?: any;
  setFieldValue: any;
  isValid?: any;
  isInvalid?: any;
  disabled?: boolean;
}

const maskPhoneNumber = (value: string) => {
  const onlyNums = value.replace(/\D/g, '');
  if (onlyNums.length <= 3) {
    return `(${onlyNums}`;
  }
  if (onlyNums.length <= 6) {
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`;
  }
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const InputBoxPhone: React.FC<InputBoxPhoneProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  setFieldValue,
  onBlur,
  isValid,
  isInvalid,
  disabled = false,
}) => {
  React.useEffect(() => {
    setFieldValue(name, value);
  }, [value, setFieldValue, name]);

  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <InputGroup.Text>+1</InputGroup.Text>
        <Form.Control
          type={type}
          name={name}
          placeholder={placeholder || '(xxx) xxx-xxxx'}
          required={required}
          value={value}
          // onChange={onChange}
          onChange={(e) => {
            const maskedValue = maskPhoneNumber(e.target.value);
            setFieldValue(name, maskedValue);
          }}
          onBlur={onBlur}
          isValid={isValid}
          isInvalid={isInvalid}
          disabled={disabled}
        />
        <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};
